import { useEffect, useState } from 'react';
import { Box, Typography, Paper, Stack, Button, Table, TableHead, TableRow, TableCell, TableBody, Chip, Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormGroup, FormControlLabel, Checkbox, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import LockResetIcon from '@mui/icons-material/LockReset';
import { api } from '../services/api';

export default function UsersPage() {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = useState(false);
  const [reset, setReset] = useState(null);

  const load = async () => {
    const [a, b] = await Promise.all([api.get('/api/users'), api.get('/api/roles')]);
    setUsers(a.data); setRoles(b.data);
  };
  useEffect(() => { load(); }, []);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Users</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>Add User</Button>
      </Stack>
      <Paper>
        <Table>
          <TableHead><TableRow><TableCell>Email</TableCell><TableCell>Name</TableCell><TableCell>Roles</TableCell><TableCell>Status</TableCell><TableCell>Last login</TableCell><TableCell /></TableRow></TableHead>
          <TableBody>
            {users.map(u => (
              <TableRow key={u.id}>
                <TableCell>{u.email}</TableCell>
                <TableCell>{u.firstName} {u.lastName}</TableCell>
                <TableCell>{(u.roles || []).map(r => <Chip key={r} size="small" label={r} sx={{ mr: 0.5 }} />)}</TableCell>
                <TableCell><Chip size="small" label={u.isActive ? 'Active' : 'Inactive'} color={u.isActive ? 'success' : 'default'} /></TableCell>
                <TableCell>{u.lastLoginAt ? new Date(u.lastLoginAt).toLocaleString() : '—'}</TableCell>
                <TableCell><IconButton onClick={() => setReset(u)}><LockResetIcon /></IconButton></TableCell>
              </TableRow>
            ))}
            {users.length === 0 && <TableRow><TableCell colSpan={6} align="center">No users</TableCell></TableRow>}
          </TableBody>
        </Table>
      </Paper>
      <UserDialog open={open} onClose={() => setOpen(false)} onSaved={() => { setOpen(false); load(); }} roles={roles} />
      <ResetPasswordDialog user={reset} onClose={() => setReset(null)} onSaved={() => { setReset(null); load(); }} />
    </Box>
  );
}

function UserDialog({ open, onClose, onSaved, roles }) {
  const [f, setF] = useState({ email: '', firstName: '', lastName: '', phoneNumber: '', roleIds: [] });
  const toggle = (id) => setF(s => ({ ...s, roleIds: s.roleIds.includes(id) ? s.roleIds.filter(x => x !== id) : [...s.roleIds, id] }));
  const submit = async () => { await api.post('/api/users', f); onSaved(); };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>New user</DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField label="Email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} />
          <Stack direction="row" spacing={2}>
            <TextField label="First name" required value={f.firstName} onChange={(e) => setF({ ...f, firstName: e.target.value })} fullWidth />
            <TextField label="Last name" required value={f.lastName} onChange={(e) => setF({ ...f, lastName: e.target.value })} fullWidth />
          </Stack>
          <TextField label="Phone" value={f.phoneNumber} onChange={(e) => setF({ ...f, phoneNumber: e.target.value })} />
          <Typography variant="subtitle2">Roles</Typography>
          <FormGroup>
            {roles.map(r => <FormControlLabel key={r.id} control={<Checkbox checked={f.roleIds.includes(r.id)} onChange={() => toggle(r.id)} />} label={r.name} />)}
          </FormGroup>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={!f.email || !f.firstName}>Create</Button>
      </DialogActions>
    </Dialog>
  );
}

function ResetPasswordDialog({ user, onClose, onSaved }) {
  const [pwd, setPwd] = useState('');
  const submit = async () => { await api.post(`/api/users/${user.id}/reset-password`, { newPassword: pwd, mustChange: true }); onSaved(); };
  return (
    <Dialog open={!!user} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Reset password for {user?.email}</DialogTitle>
      <DialogContent>
        <TextField label="New password" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} fullWidth sx={{ mt: 1 }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={submit} disabled={pwd.length < 8}>Reset</Button>
      </DialogActions>
    </Dialog>
  );
}
